<template>
  <div :class="[deviceType, 'inner']">
    <div class="content">
      <div class="popup-sign">
        <AcknowledgementDeclinedSvg></AcknowledgementDeclinedSvg>
      </div>
    </div>
  </div>

  <div class="top-up-successful">
    {{ t("ccOnBoarding.acknowledgement.otpMax") }}
  </div>
  <div class="refNo">
    {{ t("ccOnBoarding.acknowledgement.refNo") }} {{ prop.refNo }}
  </div>
</template>
<script setup lang="ts">
import i18n from "@/plugin/i18n";
import { ref, onBeforeMount, onMounted } from "vue";
import { deviceDetect } from "mobile-device-detect";
import AcknowledgementDeclinedSvg from "@/assets/icons/AcknowledgementDeclinedSvg.vue";

const { t } = i18n.global;

const deviceType = ref("");

const prop = defineProps({
  refNo: {
    type: String,
  },
});

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});
</script>

<style scoped>
.content {
  display: flex;
  justify-content: center;
  margin: 0;
}

.top-up-successful,
.top-up-successful * {
  margin-top: 20px;
  box-sizing: border-box;
}
.top-up-successful {
  color: var(--primary-active, #ac2887);
  text-align: center;
  font: 500 22px/130% "outfit";
  position: relative;
  align-self: stretch;
}

.wallet-limit-up-to-m,
.wallet-limit-up-to-m * {
  box-sizing: border-box;
  margin-top: 16px;
}
.wallet-limit-up-to-m {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;
  font-family: var(--subtitle-1-medium-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-1-medium-font-size, 16px);
  line-height: var(--subtitle-1-medium-line-height, 130%);
  font-weight: var(--subtitle-1-medium-font-weight, 500);
  position: relative;
  align-self: stretch;
}

.popup-sign,
.popup-sign * {
  box-sizing: border-box;
}
.popup-sign {
  background: var(--alert-negative, #df0029);
  border-radius: 60px;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  position: relative;
}
.group-208 {
  height: auto;
  position: absolute;
  left: calc(50% - 11px);
  top: calc(50% - 12px);
  overflow: visible;
}

.refNo {
  color: var(--web-black-high, #212121);
  text-align: center;
  font-family: var(--h-3-font-family, "Outfit", sans-serif);
  font-size: var(--h-3-font-size, 18px);
  line-height: var(--h-3-line-height, 130%);
  font-weight: var(--h-3-font-weight, 500);
  position: relative;
  align-self: stretch;
  margin-top: 16px;
}

@media (max-width: 500px) {
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}
</style>
